module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout mdl-js-layout mdl-layout--fixed-header"
  }, [_c('header', {
    staticClass: "mdl-layout__header"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_c('mdl-select', {
    attrs: {
      "label": "Dzień",
      "id": "slug-select",
      "value": _vm.slug,
      "options": _vm.days
    },
    on: {
      "input": _vm.goToDay
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('nav', {
    staticClass: "mdl-navigation"
  }, [(_vm.card && _vm.thereAreChangedRecordsFor(_vm.card)) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent",
    attrs: {
      "disabled": _vm.offline || _vm.updating
    },
    on: {
      "click": function($event) {
        _vm.updateCard(_vm.card)
      }
    }
  }, [(_vm.offline) ? [_vm._v("offline")] : [(_vm.updating) ? [_vm._v("wysyłam... "), _c('mdl-spinner', {
    attrs: {
      "single-color": ""
    }
  })] : [_vm._v("Wyślij")]]], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout__drawer"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")])])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin": "0 auto",
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.searchFocus),
      expression: "searchFocus"
    }],
    staticClass: "mdl-textfield__input",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "text",
      "id": "sample1",
      "placeholder": "Szukaj..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "focus": function($event) {
        _vm.searchFocus = true
      },
      "blur": function($event) {
        _vm.searchFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search),
      expression: "search"
    }],
    staticStyle: {
      "position": "absolute",
      "right": "2px",
      "top": "2px"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearSearch($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])])]), _vm._v(" "), (_vm.card) ? _c('nav', {
    staticClass: "mdl-navigation"
  }, _vm._l((_vm.filteredCardRecords), function(record) {
    return _c('router-link', {
      key: record.id,
      staticClass: "mdl-navigation__link",
      attrs: {
        "to": _vm.getRouteToEdit(record)
      },
      nativeOn: {
        "click": function($event) {
          _vm.hideMenu($event)
        }
      }
    }, [_c('strong', [(record.changed) ? _c('i', {
      staticClass: "material-icons",
      staticStyle: {
        "color": "#8bc34a"
      }
    }, [_vm._v("edit")]) : _vm._e(), _vm._v("\n          " + _vm._s(record.product.name) + "\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), (record.product.variety) ? [_vm._v(_vm._s(record.product.variety) + ",")] : _vm._e(), _vm._v("\n        " + _vm._s(record.product.origin) + ",\n        " + _vm._s(record.product.unit) + "\n      ")], 2)
  })) : _c('my-spinner')], 1), _vm._v(" "), _c('main', {
    staticClass: "mdl-layout__content"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fc0a706","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Records.vue
// module id = 262
// module chunks = 1